import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { API_URL } from "../../api/APIUrl";

const AdminUserList = ({ visible }) => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modal2IsOpen, setModal2IsOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);

  // Set to 8 to fit the screen without scrolling
  const itemsPerPage = 8;

  const [newUser, setNewUser] = useState({
    username: "",
    email: "",
    country: "",
    isAdmin: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditUser({ ...editUser, [name]: value });
  };

  const handleUserInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "isAdmin" ? value === "true" : value;
    setNewUser({ ...newUser, [name]: newValue });
  };

  const handleSave = async (event) => {
    event.preventDefault();
    fetch(`${API_URL}/api/users/edit/${editUser._id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editUser),
    })
      .then((r) => r.json())
      .then(() => {
        getAllUsers();
        closeModal();
      });
  };

  const handleCreate = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/users/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: newUser.username.toUpperCase(),
          email: newUser.email,
          isAdmin: newUser.isAdmin,
          password: newUser.password,
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        alert(data.message || "Failed to create user");
        return;
      }

      getAllUsers();
      setNewUser({ username: "", email: "", country: "", isAdmin: false });
      closeModal2();
    } catch (error) {
      console.error("Error creating user:", error);
      alert("Failed to create user. Please try again.");
    }
  };

  const handleDelete = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
    try {
      const response = await fetch(`${API_URL}/api/users/${userId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert("Error deleting user: " + errorData.message);
        return;
      }
      getAllUsers();
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete user. Please try again.");
    }
  };

  const openModal = (post) => {
    setEditUser(post);
    setModalIsOpen(true);
  };
  const openModal2 = () => setModal2IsOpen(true);
  const closeModal = () => {
    setModalIsOpen(false);
    setEditUser(null);
  };
  const closeModal2 = () => setModal2IsOpen(false);

  function getAllUsers() {
    fetch(`${API_URL}/api/users`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((r) => r.json())
      .then((data) => setUsers(data));
  }

  useEffect(() => {
    getAllUsers();
  }, []);

  const filteredUsers = users.filter((user) => {
    const searchLower = searchTerm.toLowerCase();
    const matchesUsername = user.username?.toLowerCase().includes(searchLower);
    const matchesEmail = user.email?.toLowerCase().includes(searchLower);
    return matchesUsername || matchesEmail;
  });

  const finalIndex = currentPage * itemsPerPage;
  const startingIndex = finalIndex - itemsPerPage;
  const items = filteredUsers.slice(startingIndex, finalIndex);
  const npage = Math.ceil(filteredUsers.length / itemsPerPage);

  // Calculates how many empty row structures are needed to reach full height alignment
  const emptyRowsCount = itemsPerPage - items.length;

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  function prePage() {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) setCurrentPage(currentPage + 1);
  }

  function getPageRange(current, total) {
    const range = [];
    if (total <= 6) {
      for (let i = 1; i <= total; i++) range.push(i);
    } else {
      range.push(1);
      if (current > 4) range.push("...");
      if (current > 3 && current < total - 2) {
        range.push(current - 1, current, current + 1);
      } else if (current <= 3) {
        range.push(2, 3, 4);
      } else {
        range.push(total - 3, total - 2, total - 1);
      }
      if (current < total - 3) range.push("...");
      range.push(total);
    }
    return range;
  }

  // --- UI DESIGN STYLING CARDS ---
  const layoutContainerStyle = {
    display: visible === false ? "none" : "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    padding: "20px 0px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  };

  const headerContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    flexShrink: 0,
  };

  const titleStyle = {
    margin: 0,
    fontSize: "26px",
    fontWeight: "800",
    color: "#0f172a",
    letterSpacing: "-0.5px",
  };

  const searchInputStyle = {
    width: "100%",
    maxWidth: "360px",
    padding: "12px 16px",
    borderRadius: "10px",
    border: "1px solid #e2e8f0",
    fontSize: "14px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.01)",
    marginBottom: "24px",
    flexShrink: 0,
  };

  const addUserBtnStyle = {
    backgroundColor: "#007bff",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0, 123, 255, 0.15)",
  };

  const tableCardFrameStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    border: "1px solid #eef2f6",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.02)",
    overflow: "hidden",
    flexGrow: 0,
    minHeight: 0,
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
  };

  const thStyle = {
    backgroundColor: "#f8fafc",
    color: "#64748b",
    fontWeight: "700",
    fontSize: "13px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    padding: "16px 24px",
    textAlign: "left",
    borderBottom: "1px solid #eef2f6",
  };

  const tdStyle = {
    padding: "16px 24px",
    fontSize: "14px",
    color: "#334155",
    borderBottom: "1px solid #eef2f6",
    textAlign: "left",
    height: "53px", // Explicit height locks rows cleanly into uniform alignment
    boxSizing: "border-box",
  };

  const actionBtnStyle = (isDelete) => ({
    backgroundColor: isDelete ? "transparent" : "#f1f5f9",
    color: isDelete ? "#dc3545" : "#475569",
    border: isDelete ? "1px solid #fee2e2" : "none",
    borderRadius: "8px",
    padding: "6px 14px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    marginRight: "8px",
  });

  const paginationStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    padding: "20px 24px",
    backgroundColor: "#ffffff",
    borderTop: "1px solid #eef2f6",
    flexShrink: 0,
  };

  const pageBtnStyle = (isActive) => ({
    backgroundColor: isActive ? "#007bff" : "#ffffff",
    color: isActive ? "#ffffff" : "#475569",
    border: isActive ? "1px solid #007bff" : "1px solid #e2e8f0",
    borderRadius: "8px",
    padding: "6px 12px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
  });

  const modalOverlayStyles = {
    overlay: {
      backgroundColor: "rgba(15, 23, 42, 0.4)",
      backdropFilter: "blur(4px)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      position: "relative",
      width: "100%",
      maxWidth: "460px",
      inset: "auto",
      background: "#ffffff",
      borderRadius: "16px",
      padding: "32px",
      border: "none",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.1)",
    },
  };

  const modalTitleStyle = {
    margin: "0 0 24px 0",
    fontSize: "20px",
    fontWeight: "800",
    color: "#0f172a",
  };
  const formGroupStyle = {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  };
  const labelStyle = { fontSize: "13px", fontWeight: "600", color: "#475569" };
  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    fontSize: "15px",
    boxSizing: "border-box",
  };
  const submitBtnStyle = {
    backgroundColor: "#007bff",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "12px",
    fontWeight: "600",
    cursor: "pointer",
    flexGrow: 1,
  };
  const cancelBtnStyle = {
    backgroundColor: "#f1f5f9",
    color: "#475569",
    border: "none",
    borderRadius: "8px",
    padding: "12px",
    fontWeight: "600",
    cursor: "pointer",
    flexGrow: 1,
  };

  if (!visible) return null;

  return (
    <div style={layoutContainerStyle}>
      {/* HEADER CONTROLS */}
      <div style={headerContainerStyle}>
        <h1 style={titleStyle}>User Management</h1>
        <button style={addUserBtnStyle} onClick={openModal2}>
          Add User
        </button>
      </div>

      {/* FILTER SEARCH FIELD */}
      <div style={{ textAlign: "left" }}>
        <input
          type="text"
          placeholder="Search by username or email..."
          style={searchInputStyle}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* MAIN DATA BLOCK WRAPPER FRAME */}
      <div style={tableCardFrameStyle}>
        <div>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Username</th>
                <th style={thStyle}>Email Address</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                <>
                  {/* Active Content Rows */}
                  {items.map((user) => (
                    <tr key={user._id} style={{ backgroundColor: "#ffffff" }}>
                      <td style={tdStyle}>
                        <span style={{ fontWeight: "600", color: "#0f172a" }}>
                          {user.username}
                        </span>
                      </td>
                      <td style={tdStyle}>{user.email}</td>
                      <td style={tdStyle}>
                        <button
                          style={actionBtnStyle(false)}
                          onClick={() => openModal(user)}
                        >
                          Edit
                        </button>
                        <button
                          style={actionBtnStyle(true)}
                          onClick={() => handleDelete(user._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}

                  {/* Clean Visual Filler Spacers to eliminate structural shifts */}
                  {emptyRowsCount > 0 &&
                    Array.from({ length: emptyRowsCount }).map((_, index) => (
                      <tr
                        key={`empty-${index}`}
                        style={{ backgroundColor: "#ffffff" }}
                      >
                        <td style={tdStyle}>&nbsp;</td>
                        <td style={tdStyle}>&nbsp;</td>
                        <td style={tdStyle}>&nbsp;</td>
                      </tr>
                    ))}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="3"
                    style={{
                      ...tdStyle,
                      textAlign: "center",
                      color: "#94a3b8",
                      padding: "40px",
                      height: "auto",
                    }}
                  >
                    No user accounts matching "{searchTerm}" found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* LOCKED NAVIGATION BAR FOOTER PANEL */}
        {npage > 0 && (
          <div style={paginationStyle}>
            <button
              onClick={prePage}
              disabled={currentPage === 1}
              style={{
                ...pageBtnStyle(false),
                opacity: currentPage === 1 ? 0.4 : 1,
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              Previous
            </button>
            {getPageRange(currentPage, npage).map((page, index) =>
              page === "..." ? (
                <span
                  key={index}
                  style={{
                    color: "#94a3b8",
                    padding: "0 4px",
                    fontWeight: "600",
                  }}
                >
                  ...
                </span>
              ) : (
                <button
                  key={index}
                  onClick={() => changeCPage(page)}
                  style={pageBtnStyle(currentPage === page)}
                >
                  {page}
                </button>
              )
            )}
            <button
              onClick={nextPage}
              disabled={currentPage === npage}
              style={{
                ...pageBtnStyle(false),
                opacity: currentPage === npage ? 0.4 : 1,
                cursor: currentPage === npage ? "not-allowed" : "pointer",
              }}
            >
              Next
            </button>
          </div>
        )}
      </div>

      {/* MODALS */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={modalOverlayStyles}
      >
        <h3 style={modalTitleStyle}>Edit User Account</h3>
        {editUser && (
          <form onSubmit={handleSave}>
            <div style={formGroupStyle}>
              <label style={labelStyle}>Username</label>
              <input
                type="text"
                style={inputStyle}
                name="username"
                value={editUser.username}
                onChange={handleInputChange}
                required
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>Country</label>
              <input
                type="text"
                style={inputStyle}
                name="country"
                value={editUser.country || ""}
                onChange={handleInputChange}
                required
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>Email Address</label>
              <input
                type="text"
                style={inputStyle}
                name="email"
                value={editUser.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div style={formGroupStyle}>
              <label style={labelStyle}>Role Permissions</label>
              <select
                style={inputStyle}
                name="isAdmin"
                value={editUser.isAdmin}
                onChange={handleInputChange}
                required
              >
                <option value={false}>Standard User</option>
                <option value={true}>Administrator</option>
              </select>
            </div>
            <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
              <button style={submitBtnStyle} type="submit">
                Update User
              </button>
              <button style={cancelBtnStyle} type="button" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </Modal>

      <Modal
        isOpen={modal2IsOpen}
        onRequestClose={closeModal2}
        style={modalOverlayStyles}
      >
        <h3 style={modalTitleStyle}>Create New User</h3>
        <form onSubmit={handleCreate}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Username</label>
            <input
              type="text"
              style={inputStyle}
              name="username"
              value={newUser.username}
              placeholder="e.g. JOHNDOE"
              onChange={handleUserInputChange}
              required
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Temporary Password</label>
            <input
              type="password"
              style={inputStyle}
              name="password"
              value={newUser.password || ""}
              placeholder="••••••••"
              onChange={handleUserInputChange}
              required
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Email Address</label>
            <input
              type="email"
              style={inputStyle}
              name="email"
              value={newUser.email}
              placeholder="name@company.com"
              onChange={handleUserInputChange}
              required
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Role Permissions</label>
            <select
              style={inputStyle}
              name="isAdmin"
              value={newUser.isAdmin}
              onChange={handleUserInputChange}
              required
            >
              <option value={false}>Standard User</option>
              <option value={true}>Administrator</option>
            </select>
          </div>
          <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
            <button style={submitBtnStyle} type="submit">
              Create User
            </button>
            <button style={cancelBtnStyle} type="button" onClick={closeModal2}>
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default AdminUserList;
